export const completePasswordPattern =
    "(?=.*[a-z]+)(?=.*[A-Z]+)(?=.*[0-9]+)(?=.*([^w\\n]|_)+)([a-zA-Z0-9]|[^w\\n]|_)+";
